import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import { makeStyles } from '@mui/styles'; 
import TextField from '@mui/material/TextField';
import DialogTitle from '@mui/material/DialogTitle';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";


const useStyles = makeStyles(theme => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
 
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));



export default class  Businesschangepassword extends Component {


 constructor(props) {
    super();

    this.state = { redirect:false,pagename:'',OldPassword: '' ,alertype:"error",NewPassword:'',ConfirmNewPassword:'',ur_id:'',
	
	btndisabled:false,
submitbtn:"Change Password",confirmshowpassword:false,NewshowPassword:false,
OldshowPassword:false,errormessage:'',erropen:false,
	};
   
}




myChangeHandler = (event) => {
	
	  const re =/^\-{0,1}\d+(.\d+){0,1}$/;
	  
	  
  let nam = event.target.name;
  let val = event.target.value;
    
  this.setState({[nam]: val});
  
  
}




	componentWillMount  () {
	

	
	
	
	if(localStorage.getItem("GBuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Businesslogin'
          })
		  }
}
validateForm() {
    return (
      this.state.OldPassword.length > 0 &&
      this.state.NewPassword.length > 0 &&
      this.state.NewPassword === this.state.ConfirmNewPassword
    );
}



 
  
handleChange = event => {
let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val});
 };

 handleChangeClick =  (event) => {
    event.preventDefault();
  
   let OldPassword = this.state.OldPassword;
 
   let NewPassword = this.state.NewPassword;
  // let ConfirmNewPassword = this.state.NewPassword;
   let ConfirmNewPassword = this.state.ConfirmNewPassword;
   
   if(OldPassword==="")
{
	this.setState({errormessage:"Please Enter Old Password.",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}
   if(NewPassword==="")
{
	
	this.setState({errormessage:"Please Enter New Password.",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
}
   
    if(ConfirmNewPassword==="")
{
	
	this.setState({errormessage:"Please Enter Confirm Password.",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
}
  
  if(NewPassword!=ConfirmNewPassword)
  {
	
  this.setState({errormessage:"Please ReType Correct Password.",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
  }
    this.setState({btndisabled:true,submitbtn:"Processing..."}) 
var formData = new FormData();
    formData.append('action','changepaswrd')
	formData.append('bu_id',localStorage.getItem("GBuserid"))
	formData.append('oldpassword',OldPassword)
	formData.append('newpassword',NewPassword)
	 formData.append("retypepassword", ConfirmNewPassword);
	
	
axios.post(Serverurl + "ajaxbusiness.php", formData)
.then(res => {

    console.log(res.data); 

    const msg = Number(res.data[0].message);
console.log(msg);
    if (msg === 1) {

    this.setState({
        errormessage: "Password updated successfully.",
        erropen: true,
        alertype: "success",
        btndisabled: false,
        submitbtn: "Change Password",
        OldPassword: "",
        NewPassword: "",
        ConfirmNewPassword: ""
    });

    setTimeout(() => {

        this.setState({
            redirect: true,
            pagename: "/Businesslogin"
        });

    }, 1500);

}
    else if (msg === -1) {

        this.setState({
            errormessage: "Old password is incorrect.",
            erropen: true,
            alertype: "error",
            btndisabled: false,
            submitbtn: "Change Password"
        });

    }
    else if (msg === -2) {

        this.setState({
            errormessage: "New password and confirm password do not match.",
            erropen: true,
            alertype: "error",
            btndisabled: false,
            submitbtn: "Change Password"
        });

    }

});
 
    
  };

  handleClickConfirmpassowrd = () => {
    this.setState({ confirmshowpassword: !this.state.confirmshowpassword });
  };
  
  handleClickOldShowPassword = () => {
    
	this.setState({
            OldshowPassword: !this.state.OldshowPassword
          })
  };
  
  
   handleClickNewShowPassword = () => {
    
	this.setState({
            NewshowPassword: !this.state.NewshowPassword
          })
  };
	
	  handleMouseDownPassword = event => {
    event.preventDefault();
  };

	  handleMouseDownPassword1 = event => {
    event.preventDefault();
  };	


  handleMouseDownPassword2 = event => {
    event.preventDefault();
  };
  
   handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  } 
  goBack = () => {
  window.history.back();
};
render() {

if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    } 
return (

				
<React.Fragment>


<div className="boxheading">
  <div className="heading-with-back">
               <ChevronLeftIcon
  className="global-back-arrow"
  onClick={() => window.history.back()}
/>
    <h2>Change Password</h2>
  </div>
</div>

	<div className="clear"></div>
<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity={this.state.alertype}
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>


<form className={useStyles.form} onSubmit={this.handleChangeClick}>

<div className="formmain">
 

<div className="changepasswordbg">

{/*<p><span className="validation">*</span>Old Password </p>*/}
 
		  
<p className="chngtxt"><FormControl fullWidth  variant="outlined">
<InputLabel shrink htmlFor="OldPassword">
  Old Password
</InputLabel>
 
          <OutlinedInput value={this.state.OldPassword}
            id="OldPassword" name="OldPassword" 
			  placeholder="Old Password"
			type={this.state.OldshowPassword ? 'text' : 'password'}
			  label="Old Password"
            onChange={this.myChangeHandler}
			inputProps={{tabIndex: "1",maxLength:15}} 
			size="small"
					size="small"
	style={{
    paddingLeft: "10px",
  }}
            endAdornment={<InputAdornment position="start"> <IconButton
                     onClick={this.handleClickOldShowPassword}
                  onMouseDown={this.handleMouseDownPassword}  >
				  { this.state.OldshowPassword ? <Visibility /> : <VisibilityOff />}
                
                </IconButton></InputAdornment>}
           />
         
        </FormControl>	</p>  
		  
		  
		  


		  {/*<p ><span className="validation">*</span>New Password </p>*/}
         
		  
		  
		  		  
<p className="chngtxt"><FormControl fullWidth  variant="outlined">
<InputLabel shrink htmlFor="OldPassword">
 New Password
</InputLabel>
 
          <OutlinedInput value={this.state.NewPassword}
            id="NewPassword" name="NewPassword" 
			 placeholder="New Password "
			 label="New Password"
			type={this.state.NewshowPassword ? 'text' : 'password'}
            onChange={this.myChangeHandler}
			inputProps={{tabIndex: "2",maxLength:15}} InputLabelProps={{ shrink: true }}  
			size="small"
	style={{
    paddingLeft: "10px",
  }}
            endAdornment={<InputAdornment position="start"> <IconButton
                     onClick={this.handleClickNewShowPassword}
                  onMouseDown={this.handleMouseDownPassword1}  >
				  { this.state.NewshowPassword ? <Visibility /> : <VisibilityOff />}
                
                </IconButton></InputAdornment>}
           />
         
        </FormControl>	</p>  


{/*<p><span className="validationt">*</span> Confirm Password </p>*/}

		  
		  		  
<p className="chngtxt"><FormControl fullWidth  variant="outlined">
<InputLabel shrink htmlFor="OldPassword">
Confirm Password
</InputLabel>
 
          <OutlinedInput value={this.state.ConfirmNewPassword}
            id="ConfirmNewPassword" 
			label="Confirm Password"
			name="ConfirmNewPassword" 
			placeholder="Confirm Password"
		type={this.state.confirmshowpassword ? "text" : "password"}
            onChange={this.myChangeHandler}
			
			inputProps={{tabIndex: "3",maxLength:15}} InputLabelProps={{ shrink: true }}  
			size="small"
					size="small"
	style={{
    paddingLeft: "10px",
  }}
            endAdornment={<InputAdornment position="start"> <IconButton
                     onClick={this.handleClickConfirmpassowrd}
                  onMouseDown={this.handleMouseDownPassword2}  >
				  { this.state.confirmshowpassword ? <Visibility /> : <VisibilityOff />}
                
                </IconButton></InputAdornment>}
           />
         
        </FormControl>	</p>  

 <p className="aligncentr"><Button
            type="submit"
           halfWidth
			disabled={this.state.btndisabled}
            variant="contained" 
         
         
            className="primartybtn"
          >
            {this.state.submitbtn}
          </Button></p>

</div></div>
</form>



</React.Fragment>

     );
    }
   }



  